/**
 * Generate a cryptographically random string for PKCE
 */
export function generateRandomString(length: number): string {
  const array = new Uint8Array(length);

  crypto.getRandomValues(array);

  return Array.from(array)
    .map(b => String.fromCharCode((b % 26) + 97))
    .join('');
}

/**
 * Generate SHA-256 hash for PKCE code challenge
 */
export async function sha256(plain: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  const hash = await crypto.subtle.digest('SHA-256', data);

  return base64UrlEncode(hash);
}

/**
 * Base64Url encode for PKCE
 */
function base64UrlEncode(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  const base64 = btoa(String.fromCharCode(...bytes));

  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
